<template>
  <div :class="{ 'dark-theme': isDark }">
    <Toast />
  </div>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'
import { computed, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useSettingStore } from '@/platform/settings/settingStore'
import { useToastStore } from '@/platform/updates/common/toastStore'

const toast = useToast()
const toastStore = useToastStore()
const settingStore = useSettingStore()
const route = useRoute()

// 在登录页强制使用暗色主题，以匹配 BaseViewTemplate(dark)
const isDark = computed(() => route.path.includes('/login'))

watch(
  () => toastStore.messagesToAdd,
  (newMessages) => {
    if (newMessages.length === 0) {
      return
    }

    newMessages.forEach((message) => {
      toast.add(message)
    })
    toastStore.messagesToAdd = []
  },
  { deep: true }
)

watch(
  () => toastStore.messagesToRemove,
  (messagesToRemove) => {
    if (messagesToRemove.length === 0) {
      return
    }

    messagesToRemove.forEach((message) => {
      toast.remove(message)
    })
    toastStore.messagesToRemove = []
  },
  { deep: true }
)

watch(
  () => toastStore.removeAllRequested,
  (requested) => {
    if (requested) {
      toast.removeAllGroups()
      toastStore.removeAllRequested = false
    }
  }
)

function updateToastPosition() {
  const styleElement =
    document.getElementById('dynamic-toast-style') || createStyleElement()
  const rect = document
    .querySelector('.graph-canvas-container')
    ?.getBoundingClientRect()
  if (!rect) return

  styleElement.textContent = `
    .p-toast.p-component.p-toast-top-right {
      top: ${rect.top + 20}px !important;
      right: ${window.innerWidth - (rect.left + rect.width) + 20}px !important;
    }
  `
}

function createStyleElement() {
  const style = document.createElement('style')
  style.id = 'dynamic-toast-style'
  document.head.appendChild(style)
  return style
}

watch(
  () => settingStore.get('Comfy.UseNewMenu'),
  () => nextTick(updateToastPosition),
  { immediate: true }
)
watch(
  () => settingStore.get('Comfy.Sidebar.Location'),
  () => nextTick(updateToastPosition),
  { immediate: true }
)
</script>

<style scoped>
/* 登录页暗色主题下的 Toast 样式覆盖 */
.dark-theme :deep(.p-toast) {
  color: #e5e7eb;
}
.dark-theme :deep(.p-toast .p-toast-message) {
  background: rgba(26, 26, 26, 0.95);
  border: 1px solid rgba(255, 107, 53, 0.2);
  color: #e5e7eb;
}
.dark-theme
  :deep(
    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-text
  ) {
  color: #e5e7eb;
}
.dark-theme :deep(.p-toast .p-toast-message .p-toast-icon-close) {
  color: #cbd5e1;
}
.dark-theme :deep(.p-toast .p-toast-message .p-toast-icon-close:hover) {
  background: rgba(255, 107, 53, 0.1);
}
</style>
